import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { licenseFeeService } from "@/services/license-fee-service";
import { useForm } from "@conform-to/react";
import {
  ActionFunctionArgs,
  Form,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
  useNavigation,
} from "react-router-dom";

export const action = async ({ params }: ActionFunctionArgs) => {
  if (!params.licenseFeeId) throw redirect("/");

  try {
    await licenseFeeService.deleteLicenseFee(Number(params.licenseFeeId));

    return redirect(`result?success=true`);
  } catch (error) {
    console.error(error);
    return redirect(`result?success=false`);
  }
};

export const CancelModal = () => {
  const navigate = useNavigate();
  const navigation = useNavigation();
  const { pathname } = useLocation();

  const [form] = useForm({});

  const handleClose = () => {
    navigate(-1);
  };

  if (pathname.includes("/result")) {
    return <Outlet />;
  }

  return (
    <Dialog open onOpenChange={handleClose}>
      <DialogContent
        className="self-stretch inline-flex flex-col gap-2 h-auto max-w-[530px] p-0"
        showCloseButton={false}
      >
        <DialogHeader className="p-6 bg-background pb-0">
          <DialogTitle>
            <div className="text-xl text-bg-black font-medium leading-7">
              Tem certeza de que deseja cancelar este license fee?
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="p-6 self-stretch justify-start pt-0 pb-4">
          <p className="text-sm text-gray-500 font-light">
            Ao confirmar o cancelamento:
          </p>
          <ul className="list-disc pl-5 text-sm text-gray-500 font-light">
            <li>
              O License Fee será marcado como cancelado a partir de agora.
            </li>
            <li>
              Pagamentos que já foram pagos ou faturados permanecerão
              inalterados.
            </li>
            <li>
              Pagamentos que ainda não foram pagos ou faturados serão
              cancelados.
            </li>
          </ul>
        </div>
        <Form method="post" id={form.id} onSubmit={form.onSubmit}>
          <div className="flex justify-end gap-4 pb-6 px-6">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate(-1)}
              className="px-4 py-2"
            >
              Voltar
            </Button>
            <Button
              type="submit"
              form={form.id}
              className="px-4 py-2 bg-red-500"
              disabled={navigation.state === "submitting"}
            >
              Confirmar cancelamento
            </Button>
          </div>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
